import React from 'react';
import { Switch } from 'react-router-dom';
import { useI18n } from './i18n';
import AppliedRoute from './components/Routes/AppliedRoute';
import PrivateRoute from './components/Routes/PrivateRoute';

import TaskList from './containers/Tasks/TaskList/TaskList';
import TaskCompList from './containers/Tasks/TaskCompList/TaskCompList';
import TaskCosts from './containers/Tasks/TaskCosts/TaskCosts';
import TaskDetail from './containers/Tasks/TaskDetail/TaskDetail';
import TaskAdd from './containers/Tasks/TaskAdd/TaskAdd';
import NotFound from './containers/Error/NotFound';
import Login from './containers/Auth/Login/Login';
import Signup from './containers/Auth/Signup/Signup';
import UserList from './containers/Auth/UserList/UserList';
import UserDetail from './containers/Auth/UserDetail/UserDetail';
import MonthlyReport from './containers/Reports/MonthlyReport/MonthlyReport';
import AssetList from './containers/Assets/AssetList/AssetList';
import AssetLocator from './containers/Assets/AssetLocator/AssetLocator';
import AssetLocatorBridgeDeviceTest from './containers/Assets/AssetLocatorBridgeDeviceTest/AssetLocatorBridgeDeviceTest';
import AssetAdd from './containers/Assets/AssetAdd/AssetAdd';
import AssetDetail from './containers/Assets/AssetDetail/AssetDetail';
import CostAdd from './containers/Costs/CostAdd/CostAdd';
import Inventory from './containers/Costs/Inventory/Inventory';
import Dashboard from './containers/Dashboard/Dashboard/Dashboard';
import KPIs from './containers/Indicators/KPIs';
import TaskBoard from './containers/Tasks/TaskBoard/TaskBoard';
// import Scheduler from './containers/Scheduler/Scheduler';

 const Routes = ({ childProps }) => {
	const { t } = useI18n();

	return (
	<Switch>	
		<AppliedRoute path="/login" exact component={Login} props={childProps} />
		<PrivateRoute path="/tasks" exact component={TaskList} props={childProps} />
		<PrivateRoute path="/tasks_comp" exact component={TaskCompList} props={childProps} />
		<PrivateRoute path="/tasks_costs" exact component={TaskCosts} props={childProps} />
		<PrivateRoute path="/signup" exact component={Signup} props={childProps} />
		<PrivateRoute path="/users" exact component={UserList} props={childProps} />
		<PrivateRoute path="/user_det/:id" exact component={UserDetail} props={childProps} />
		<PrivateRoute path="/task_det/:id" exact component={TaskDetail} props={childProps} />
		<PrivateRoute path="/task_add" exact component={TaskAdd} props={childProps} />
		<PrivateRoute path="/task_add/:id" exact component={TaskAdd} props={childProps} />
		<PrivateRoute path="/task_asset_add/:assetId" exact component={TaskAdd} props={childProps} />
		<PrivateRoute path="/task_board" exact component={TaskBoard} props={childProps} />
		<PrivateRoute path="/monthly_report" exact component={MonthlyReport} props={childProps} />
		<PrivateRoute path="/assets" exact component={AssetList} props={childProps} />
		<PrivateRoute path="/asset_locator" exact component={AssetLocator} props={childProps} />
		<PrivateRoute path="/asset_locator_bridges" exact component={AssetLocatorBridgeDeviceTest} props={childProps} />
		<PrivateRoute path="/asset_add" exact component={AssetAdd} props={childProps} />
		<PrivateRoute path="/asset_add/:id" exact component={AssetAdd} props={childProps} />
		<PrivateRoute path="/asset_det/:id" exact component={AssetDetail} props={childProps} />
		<PrivateRoute path="/cost_add" exact component={CostAdd} props={childProps} />
		<PrivateRoute path="/inventory" exact component={Inventory} props={childProps} />
		<PrivateRoute path="/kpis" exact component={KPIs} props={childProps} />
		{/* <PrivateRoute path="/scheduler" exact component={NotFound} props={childProps} message='This section is under construction' /> */}
		{/* <PrivateRoute path="/scheduler" exact component={Scheduler} props={childProps}  /> */}
		
		<PrivateRoute path="/" exact component={Dashboard} props={childProps} />
		{/* Finally, catch all unmatched routes */}
		<AppliedRoute component={NotFound} props={childProps} message={t('notFound.message')} />
	</Switch>
	)
 }

export default Routes;
